import React from 'react';
import { useMediaQuery } from '@mui/material';
import { Skeleton } from '@mui/material';
import { Grid } from '@mui/system';
import {
  DOCUMENT_REQUEST_DESCRIPTION,
  DOCUMENT_REQUEST_TITLE,
  QUESTION_REQUEST_DESCRIPTION,
  QUESTION_REQUEST_TITLE,
} from 'common/constants/firms';
import theme from 'theme';
import { RequestsContentProps } from './RequestContent.props';
import RequestTask from '../RequestTask/RequestTask';

const RequestsContent = ({
  documents,
  questions,
  setUpdateTaskList,
  primaryInformationRequestId,
  companyId = null,
  isInitialSetup = false,
  currentPageData,
  isCompanyTemplate = false,
}: RequestsContentProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const requestTaskProps = {
    companyId,
    setUpdateTaskList,
    primaryInformationRequestId,
    isCompanyTemplate,
  };

  return (
    <Grid
      container
      style={{
        margin: '2rem 0',
      }}>
      <Grid
        size={{ xs: 12, sm: 4 }}
        style={{
          padding: '0',
          marginRight: isMobile ? undefined : '5rem',
        }}>
        {!documents ? (
          <Skeleton variant="rect" width="100%" height={600} />
        ) : (
          <RequestTask
            {...requestTaskProps}
            isDocumentRequest
            title={DOCUMENT_REQUEST_TITLE}
            description={DOCUMENT_REQUEST_DESCRIPTION}
            tasks={documents}
            isInitialSetup={isInitialSetup}
            currentPageData={currentPageData}
          />
        )}
      </Grid>
      <Grid
        size={{ xs: 12, sm: 6 }}
        style={{
          padding: '0',
        }}>
        {!questions ? (
          <Skeleton variant="rect" width="100%" height={600} />
        ) : (
          <RequestTask
            {...requestTaskProps}
            title={QUESTION_REQUEST_TITLE}
            description={QUESTION_REQUEST_DESCRIPTION}
            tasks={questions}
            isInitialSetup={isInitialSetup}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default RequestsContent;
